import { render, staticRenderFns } from "./GameMat.vue?vue&type=template&id=6ab2e0ec&"
import script from "./GameMat.vue?vue&type=script&lang=js&"
export * from "./GameMat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports